const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

// The callApi function is defined here, in api.js
export const callApi = async (endpoint, method = 'GET', data = null, token) => {
  const headers = {
    'Content-Type': 'application/json',
  };

  let url = `${API_BASE_URL}${endpoint}`;

  // This block adds the token as a query parameter, as per your requirement.
  if (token) {
    const tokenQueryParam = `token=${token}`;
    if (url.includes('?')) {
      url += `&${tokenQueryParam}`;
    } else {
      url += `?${tokenQueryParam}`;
    }
  }

  const config = {
    method,
    headers,
  };

  if (data) {
    config.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(url, config); // Use the modified URL
    if (!response.ok) {
      const errorData = await response.json();
      const error = new Error(errorData.detail || `API request failed with status ${response.status}`);
      error.status = response.status; // Add status code to error object
      throw error;
    }
    return await response.json();
  } catch (error) {
    console.error('API call error:', error);
    throw error;
  }
};